import React from 'react';
// import { createLanguageFilters } from '@utils/supportedLanguages';
// import LanguageIcon from '@components/LanguageIcon';
import PublishedStatusColumn from '@cards/Documents/List/PublishedStatusColumn';

export default (t, defaultFilteredValue, findLanguage, findSource, contentTypeTranslationKey) => [
  // {
  //   title: t('cards:DocumentList.columns.language.title'),
  //   dataIndex: 'metadata',
  //   defaultFilteredValue: defaultFilteredValue.language || [],
  //   key: 'language',
  //   render: metadata => <LanguageIcon language={findLanguage({ metadata })} />,
  //   width: 150,
  //   // sorter will have to be modified
  //   sorter: (a, b) => (findLanguage(a) || '').localeCompare(findLanguage(b) || ''),
  //   filters: createLanguageFilters(t),
  //   onFilter: (value, record) => {
  //     return (findLanguage(record) || '').toLowerCase() === value;
  //   },
  // },
  {
    title: t(`cards:DocumentList.columns.${contentTypeTranslationKey}.title`),
    dataIndex: 'name',
    key: 'name',
    width: 250,
    ellipsis: true,
    sorter: (a, b) => a.name > b.name,
  },
  {
    title: t(`cards:DocumentList.columns.description`),
    dataIndex: 'description',
    key: 'description',
    width: 250,
    ellipsis: true,
  },
  {
    key: 'id',
    dataIndex: 'audience_type',
    width: 150,
    title: t('cards:DocumentList.columns.audience.title'),
    render: audienceType => {
      if (audienceType) return t(`cards:DocumentList.columns.audience.${audienceType}`);
      return '';
    },
    filters: [
      {
        text: t('cards:DocumentList.columns.audience.app-user'),
        value: 'app-user',
      },
      {
        text: t('cards:DocumentList.columns.audience.clinician'),
        value: 'clinician',
      },
    ],
    onFilter: (value, record) => value === record.audience_type,
  },
  {
    key: 'published',
    render: record => <PublishedStatusColumn documentId={record.id} />,
    title: t('cards:DocumentList.columns.published.title'),
    width: 120,
    className: 'published-column',
    filters: [
      {
        text: t('cards:DocumentList.columns.published.published'),
        value: true,
      },
      {
        text: t('cards:DocumentList.columns.published.unpublished'),
        value: false,
      },
    ],
    onFilter: (value, record) => value === record.published,
  },
];
